<template>
  <div :class="serviceStyle" @mouseenter="$emit('cardComponent', serviceBackComponent)">
    <div class="service-card-title-container">
      <div class="service-media">
        <v-icon color="purple lighten-3" class="service-icon">{{ serviceIcon }}</v-icon>
      </div>
      <h3 class="service-card-title">{{ serviceTitle }}</h3>
    </div>
    <ul>
      <li v-for="(option, i) in serviceOptions" :key="i" class="tile-custom ml-4">
        <v-icon>star_border</v-icon>
        <span class="ml-4">{{ option }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['serviceStyle', 'serviceIcon', 'serviceTitle', 'serviceOptions', 'serviceBackComponent'],
  data () {
    return {

    }
  }
}
</script>

<style scoped>

.grafic-service-card {
  margin-left: 30px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-around;
}

.grafic-service-card {
  margin-top: -20px;
}

.service-card-title-container {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
}

.service-card-title {
  font-size: 4em;
  margin-left: 30px;
  font-weight: 300;
}

.service-media {
  border: 1px solid #E1BEE7;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.service-icon {
  font-size: 6em;
}

.tile-custom {
  font-size: 1.2em;
  padding: 10px 0;
  list-style: none;
}

@media screen and (max-width: 780px) {
  .grafic-service-card {
    margin-top: 20px;
  }

  .service-card-title {
    font-size: 2.5em;
  }

  .service-media {
    width: 100px;
    height: 100px;
  }

  .service-icon {
    font-size: 4.5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sections/service_cards/GraficServiceCard.vue